import React from "react";
import { MUpdatePriceProduct } from "../../../../../../../server/routes/logUpdated/price/types";
import { Row } from "../../../../../components/Table/types";
import ColumnStatus from "./ColumnStatus";
import { Columns } from "./types";

const itemToRow = (item: MUpdatePriceProduct): Row<Columns> => ({
  cells: {
    id: { value: item.id },
    article: { value: item.article && item.article.replace(/ /g, "\u00A0")},
    price: { value: item.price },
    discount: { value: item.discount },
    priceBeforeDiscount: { value: item.priceBeforeDiscount },
    status: { component: <ColumnStatus item={item} /> },
    minPrice: { value: item.minPrice },
  },
});
export default itemToRow;
